/**
 * Single source of truth for currency → country mapping.
 *
 * To add a new country: add one entry here + add the currency to the backend enum.
 * No other file needs to change.
 *
 * flag: CSS class suffix used by sprite-flags-24x24.css (e.g. "br" → "flag-br")
 */
export const CURRENCY_CONFIG = {
  BRL: { country: 'BR', flag: 'br', label: 'Brasil' },
  ARS: { country: 'AR', flag: 'ar', label: 'Argentina' },
};

/** Reverse mapping: country ISO → currency ISO (e.g. 'BR' → 'BRL') */
export const COUNTRY_TO_CURRENCY = Object.fromEntries(
  Object.entries(CURRENCY_CONFIG).map(([currency, { country }]) => [country, currency])
);
